import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_REVIEWS = [
  { name: "Janet Elizabeth",  date: "24th March 2026",  rating: 5, text: "Honestly couldn't have been smoother. The team arrived bang on time, shifted two heavy wardrobes without a scratch on the walls, and were out in under 20 minutes. Brilliant service." },
  { name: "Trevor Harms",     date: "22nd March 2026",  rating: 5, text: "I've used three different clearance companies in the past two years. Cleario are in a different league. Turned up early, got stuck in, left the place spotless. Already booked them again." },
  { name: "Sarah & Ben",      date: "20th March 2026",  rating: 5, text: "Live tracking was genuinely useful — I knew exactly when they'd arrive. The guys were friendly, double-checked what we wanted gone, and even swept up after themselves. Can't fault it." },
];

export default function ReviewsSection() {
  const { data: homeCMS } = useCMSPage("home");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const reviewsCMS: any = (homeCMS as any)?.reviews ?? {};

  const headline = reviewsCMS?.headline ?? "Don't just take our word for it.";
  const badge    = reviewsCMS?.badge    ?? "Customer Reviews";
  const reviews: typeof DEFAULT_REVIEWS = reviewsCMS?.items?.length ? reviewsCMS.items : DEFAULT_REVIEWS;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">{badge}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">{headline}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review, i) => (
            <div key={i} className="bg-cl-tint rounded-2xl cartoon-card p-6 flex flex-col gap-4">
              <div className="flex items-center gap-0.5">
                {[...Array(review.rating ?? 5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#00b67a] text-sm"></i>
                ))}
              </div>
              <p className="text-cl-dark font-semibold text-sm leading-relaxed flex-1">"{review.text}"</p>
              <div className="flex items-center justify-between">
                <span className="font-black text-cl-dark text-sm">{review.name}</span>
                <span className="text-gray-400 text-xs font-semibold">{review.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
